var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{attrs:{"color":_vm.color,"content":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }